module.exports = __webpack_public_path__ + "img/161604530wt0.304b9c72.jpg";